// import React, { useState, useEffect } from 'react';
// import {
//     Box,
//     Button,
//     Grid,
//     IconButton,
//     Typography,
//     useMediaQuery,
//     useTheme,
//     Paper,
//     CircularProgress,
//     TextField,
//     MenuItem,
//     Modal,
// } from '@mui/material';
// import { Delete, AddPhotoAlternate, Close } from '@mui/icons-material';
// import Sidebar from '../components/Sidebar';
// import AdminNavbar from '../components/AdminNavbar';
// import axios from 'axios';

// const API_BASE = 'https://eleganzaestatesolutions.com/api/admin';
// const FETCH_URL = `${API_BASE}/banner-images`;
// const UPLOAD_URL = `${API_BASE}/banner/image`;
// const DELETE_URL = (id) => `${API_BASE}/banner/${id}`;

// const ImageCard = ({ img, onDelete, showDelete = true }) => (
//     <Paper elevation={3} sx={{ position: 'relative' }}>
//         <img
//             src={img.url}
//             alt="banner"
//             loading="lazy"
//             style={{ width: '100%', height: 200, objectFit: 'cover' }}
//         />
//         {showDelete && (
//             <IconButton
//                 onClick={() => onDelete(img.id)}
//                 sx={{
//                     position: 'absolute',
//                     top: 5,
//                     right: 5,
//                     backgroundColor: 'rgba(0,0,0,0.6)',
//                     color: '#fff',
//                 }}
//             >
//                 <Delete />
//             </IconButton>
//         )}
//     </Paper>
// );

// const Backgroundimage = () => {
//     const theme = useTheme();
//     const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
//     const [sidebarOpen, setSidebarOpen] = useState(!isSmallScreen);
//     const toggleDrawer = () => setSidebarOpen(!sidebarOpen);

//     const [images, setImages] = useState([]);
//     const [previewImages, setPreviewImages] = useState([]);
//     const [loading, setLoading] = useState(false);

//     const [openModal, setOpenModal] = useState(false);
//     const [properties, setProperties] = useState([]);

//     const fetchProperties = async () => {
//         try {
//             const token = localStorage.getItem("accessToken");
//             const response = await axios.get(
//                 "https://eleganzaestatesolutions.com/api/admin/properties",
//                 {
//                     headers: {
//                         Authorization: `Bearer ${token}`,
//                     },
//                 }
//             );

//             if (!response.data.error) {
//                 setProperties(response.data.meta.properties);
//             }
//         } catch (error) {
//             console.error("Error fetching properties:", error);
//         }
//     };

//     useEffect(() => {
//         fetchProperties();
//     }, []);


//     useEffect(() => {
//         const fetchImages = async () => {
//             try {
//                 const res = await axios.get(FETCH_URL);
//                 const valid = res.data.meta.filter(i => i.bannerImage);
//                 const formatted = valid.map(i => ({
//                     id: i._id,
//                     url: i.bannerImage,
//                     description: i.description || "",
//                     propertyId: i.propertyId || ""
//                 }));
//                 setImages(formatted);
//             } catch (err) {
//                 console.error('Error fetching images:', err);
//             }
//         };
//         fetchImages();
//     }, []);

//     const handleImageUpload = (e) => {
//         const files = Array.from(e.target.files);
//         const previews = files.map((file) => ({
//             id: Date.now() + Math.random(),
//             url: URL.createObjectURL(file),
//             file,
//             description: "",
//             propertyId: "",
//         }));
//         setPreviewImages(previews);
//         setOpenModal(true);
//     };

//     const handleChange = (id, field, value) => {
//         setPreviewImages(prev =>
//             prev.map(img => img.id === id ? { ...img, [field]: value } : img)
//         );
//     };

//     const handleSaveImages = async () => {
//         setLoading(true);
//         for (const img of previewImages) {
//             const formData = new FormData();
//             formData.append('bannerImage', img.file);
//             formData.append('description', img.description);
//             formData.append('propertyId', img.propertyId);

//             try {
//                 const res = await axios.post(UPLOAD_URL, formData, {
//                     headers: { 'Content-Type': 'multipart/form-data' }
//                 });
//                 setImages(prev => [
//                     ...prev,
//                     {
//                         id: Date.now() + Math.random(),
//                         url: res.data?.meta?.bannerImage || img.url,
//                         description: img.description,
//                         propertyId: img.propertyId
//                     }
//                 ]);
//             } catch (err) {
//                 console.error('Upload failed:', err);
//             }
//         }
//         setPreviewImages([]);
//         setLoading(false);
//         setOpenModal(false);
//         fetchProperties();
//     };

//     const handleDelete = async (id) => {
//         if (!window.confirm("Are you sure you want to delete this image?")) return;
//         try {
//             await axios.delete(DELETE_URL(id));
//             setImages(prev => prev.filter(img => img.id !== id));
//         } catch (err) {
//             console.error('Delete failed:', err);
//         }
//     };


//     const limitWords = (text, limit) => {
//         if (!text) return "";
//         const words = text.split(" ");
//         return words.length > limit ? words.slice(0, limit).join(" ") + "..." : text;
//     };


//     return (
//         <Box
//             display="grid"
//             gridTemplateColumns={sidebarOpen ? "200px 1fr" : "60px 1fr"}
//             sx={{
//                 transition: "grid-template-columns 0.3s ease-in-out",
//                 backgroundColor: '#f9f9f9',
//                 minHeight: '100vh',
//             }}
//         >
//             <Sidebar open={sidebarOpen} toggleDrawer={toggleDrawer} setOpen={setSidebarOpen} />

//             <Box p={2}>
//                 <AdminNavbar />
//                 <Typography variant="h6" mt={2} mb={2}>Manage Background Images (1600 * 500)</Typography>

//                 <label htmlFor="upload-image">
//                     <input
//                         accept="image/*"
//                         id="upload-image"
//                         multiple
//                         type="file"
//                         hidden
//                         onChange={handleImageUpload}
//                     />
//                     <Button
//                         variant="contained"
//                         component="span"
//                         startIcon={<AddPhotoAlternate />}
//                         sx={{ backgroundColor: '#1976d2', mb: 2 }}
//                     >
//                         Select Image(s)
//                     </Button>
//                 </label>

//                 <Modal
//                     open={openModal}
//                     onClose={() => setOpenModal(false)}
//                     aria-labelledby="modal-title"
//                     sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
//                 >
//                     <Paper sx={{ p: 3, maxWidth: 800, width: "95%", position: "relative" }}>
//                         <IconButton
//                             onClick={() => setOpenModal(false)}
//                             sx={{ position: "absolute", top: 10, right: 10 }}
//                         >
//                             <Close />
//                         </IconButton>

//                         <Typography variant="h6" mb={3}>
//                             Upload Banner Image
//                         </Typography>

//                         {previewImages.map((img) => (
//                             <Grid container spacing={3} key={img.id}>
//                                 <Grid item xs={12} md={6}>
//                                     <Paper
//                                         sx={{
//                                             borderRadius: 2,
//                                             overflow: "hidden",
//                                             boxShadow: 2,
//                                         }}
//                                     >
//                                         <img
//                                             src={img.url}
//                                             alt="preview"
//                                             style={{
//                                                 width: "100%",
//                                                 height: 260,
//                                                 objectFit: "cover",
//                                             }}
//                                         />
//                                     </Paper>
//                                 </Grid>

//                                 <Grid item xs={12} md={6}>
//                                     <TextField
//                                         label="Description"
//                                         variant="outlined"
//                                         fullWidth
//                                         multiline
//                                         minRows={3}
//                                         sx={{ mb: 1 }}
//                                         value={img.description}
//                                         onChange={(e) => {
//                                             const words = e.target.value.split(/\s+/);
//                                             if (words.length <= 30) {
//                                                 handleChange(img.id, "description", e.target.value);
//                                             } else {
//                                                 handleChange(img.id, "description", words.slice(0, 30).join(" "));
//                                             }
//                                         }}
//                                     />
//                                     <Typography variant="caption" display="block" sx={{ mb: 2 }}>
//                                         {img.description.split(/\s+/).filter(Boolean).length} / 30 words
//                                     </Typography>


//                                     <TextField
//                                         select
//                                         label="Select Property"
//                                         fullWidth
//                                         sx={{ mb: 2 }}
//                                         value={img.propertyId}
//                                         onChange={(e) => handleChange(img.id, "propertyId", e.target.value)}
//                                     >
//                                         {properties.map((property) => (
//                                             <MenuItem key={property._id} value={property._id}>
//                                                 {property?.title}
//                                             </MenuItem>
//                                         ))}
//                                     </TextField>

//                                     <Box textAlign="right">
//                                         <Button
//                                             variant="contained"
//                                             color="success"
//                                             onClick={handleSaveImages}
//                                             disabled={loading}
//                                         >
//                                             {loading ? <CircularProgress size={24} color="inherit" /> : "Save"}
//                                         </Button>
//                                     </Box>
//                                 </Grid>
//                             </Grid>
//                         ))}
//                     </Paper>
//                 </Modal>

//                 <Typography variant="subtitle1" mt={1}>Saved Images</Typography>

//                 <Grid container spacing={2}>
//                     {images.map(img => (
//                         <Grid item xs={12} sm={6} md={4} lg={3} key={img.id}>
//                             <Paper sx={{ p: 1 }}>
//                                 <ImageCard img={img} onDelete={handleDelete} />
//                                 {img?.description && (
//                                     <Typography variant="body2" mt={1}>
//                                         {limitWords(String(img?.description), 20)}
//                                     </Typography>
//                                 )}

//                                 {img?.propertyId && (
//                                     <Typography variant="caption" color="text.secondary">
//                                         Property: {(img?.propertyId?.title)}
//                                     </Typography>
//                                 )}
//                             </Paper>
//                         </Grid>
//                     ))}
//                 </Grid>
//             </Box>
//         </Box>
//     );
// };

// export default Backgroundimage;

import React, { useState, useEffect } from 'react';
import {
    Box,
    Button,
    Grid,
    IconButton,
    Typography,
    useMediaQuery,
    useTheme,
    Paper,
    CircularProgress,
    TextField,
    MenuItem,
    Modal,
} from '@mui/material';
import { Delete, AddPhotoAlternate, Close } from '@mui/icons-material';
import Sidebar from '../components/Sidebar';
import AdminNavbar from '../components/AdminNavbar';
import axios from 'axios';

const API_BASE = 'https://eleganzaestatesolutions.com/api/admin';
const FETCH_URL = `${API_BASE}/banner-images`;
const UPLOAD_URL = `${API_BASE}/banner/image`;
const DELETE_URL = (id) => `${API_BASE}/banner/${id}`;

const ImageCard = ({ img, onDelete, showDelete = true }) => (
    <Paper elevation={3} sx={{ position: 'relative' }}>
        <img
            src={img.bannerImage}
            alt="desktop banner"
            loading="lazy"
            style={{ width: '100%', height: 200, objectFit: 'cover' }}
        />
        {img.phoneImage && (
            <img
                src={img.phoneImage}
                alt="phone banner"
                loading="lazy"
                style={{ width: '100%', height: 200, objectFit: 'cover', marginTop: 5 }}
            />
        )}
        {showDelete && (
            <IconButton
                onClick={() => onDelete(img.id)}
                sx={{
                    position: 'absolute',
                    top: 5,
                    right: 5,
                    backgroundColor: 'rgba(0,0,0,0.6)',
                    color: '#fff',
                }}
            >
                <Delete />
            </IconButton>
        )}
    </Paper>
);

const Backgroundimage = () => {
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
    const [sidebarOpen, setSidebarOpen] = useState(!isSmallScreen);
    const toggleDrawer = () => setSidebarOpen(!sidebarOpen);

    const [images, setImages] = useState([]);
    const [previewDesktop, setPreviewDesktop] = useState(null);
    const [previewPhone, setPreviewPhone] = useState(null);
    const [desktopFile, setDesktopFile] = useState(null);
    const [phoneImage, setPhoneImage] = useState(null);
    const [loading, setLoading] = useState(false);

    const [openModal, setOpenModal] = useState(false);
    const [properties, setProperties] = useState([]);
    const [propertyId, setPropertyId] = useState("");

    useEffect(() => {
        fetchProperties();
        fetchImages();
    }, []);

    const fetchProperties = async () => {
        try {
            const token = localStorage.getItem("accessToken");
            const response = await axios.get(
                `${API_BASE}/properties`,
                { headers: { Authorization: `Bearer ${token}` } }
            );
            if (!response.data.error) setProperties(response.data.meta.properties);
        } catch (error) {
            console.error("Error fetching properties:", error);
        }
    };

    const fetchImages = async () => {
        try {
            const res = await axios.get(FETCH_URL);
            const valid = res.data.meta.filter(i => i.bannerImage || i.phoneImage);
            const formatted = valid.map(i => ({
                id: i._id,
                bannerImage: i.bannerImage || null,
                phoneImage: i.phoneImage || null,
                propertyId: i.propertyId || ""
            }));
            setImages(formatted);
        } catch (err) {
            console.error('Error fetching images:', err);
        }
    };

    const handleDesktopSelect = (e) => {
        const file = e.target.files[0];
        if (!file) return;
        setDesktopFile(file);
        setPreviewDesktop(URL.createObjectURL(file));
        setOpenModal(true);
    };

    const handlePhoneSelect = (e) => {
        const file = e.target.files[0];
        if (!file) return;
        setPhoneImage(file);
        setPreviewPhone(URL.createObjectURL(file));
    };

    const handleSaveImages = async () => {
        if (!desktopFile && !phoneImage) return;
        setLoading(true);

        const formData = new FormData();
        if (desktopFile) formData.append('bannerImage', desktopFile);
        if (phoneImage) formData.append('phoneImage', phoneImage);
        formData.append('propertyId', propertyId);

        try {
            const res = await axios.post(UPLOAD_URL, formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });

            const uploaded = {
                id: res.data?.meta?._id || Date.now() + Math.random(),
                bannerImage: res.data?.meta?.bannerImage || previewDesktop,
                phoneImage: res.data?.meta?.phoneImage || previewPhone,
                propertyId
            };
            setImages(prev => [...prev, uploaded]);
        } catch (err) {
            console.error('Upload failed:', err);
        }

        setDesktopFile(null);
        setPhoneImage(null);
        setPreviewDesktop(null);
        setPreviewPhone(null);
        setPropertyId("");
        setLoading(false);
        setOpenModal(false);
    };

    const handleDelete = async (id) => {
        if (!window.confirm("Are you sure you want to delete this image?")) return;
        try {
            await axios.delete(DELETE_URL(id));
            setImages(prev => prev.filter(img => img.id !== id));
        } catch (err) {
            console.error('Delete failed:', err);
        }
    };

    return (
        <Box
            display="grid"
            gridTemplateColumns={sidebarOpen ? "200px 1fr" : "60px 1fr"}
            sx={{ transition: "grid-template-columns 0.3s ease-in-out", backgroundColor: '#f9f9f9', minHeight: '100vh' }}
        >
            <Sidebar open={sidebarOpen} toggleDrawer={toggleDrawer} setOpen={setSidebarOpen} />

            <Box p={2}>
                <AdminNavbar />
                <Typography variant="h6" mt={2} mb={2}>Manage Background Images (1600 * 500)</Typography>

                <label htmlFor="upload-desktop">
                    <input
                        accept="image/*"
                        id="upload-desktop"
                        type="file"
                        hidden
                        onChange={handleDesktopSelect}
                    />
                    <Button
                        variant="contained"
                        component="span"
                        startIcon={<AddPhotoAlternate />}
                        sx={{ backgroundColor: '#1976d2', mb: 2 }}
                    >
                        Select Desktop Image
                    </Button>
                </label>

                {/* Modal */}
                <Modal
                    open={openModal}
                    onClose={() => setOpenModal(false)}
                    aria-labelledby="modal-title"
                    sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
                >
                    <Paper sx={{ p: 3, maxWidth: 800, width: "95%", position: "relative" }}>
                        <IconButton
                            onClick={() => setOpenModal(false)}
                            sx={{ position: "absolute", top: 10, right: 10 }}
                        >
                            <Close />
                        </IconButton>

                        <Typography variant="h6" mb={3}>Upload Banner Images</Typography>

                        <Grid container spacing={3}>
                            {previewDesktop && (
                                <Grid item xs={12} md={6}>
                                    <Paper sx={{ borderRadius: 2, overflow: "hidden", boxShadow: 2 }}>
                                        <img
                                            src={previewDesktop}
                                            alt="desktop preview"
                                            style={{ width: "100%", height: 200, objectFit: "contain" }}
                                        />
                                        <Typography variant="caption" display="block" mt={1} textAlign="center">
                                            Desktop (1600 * 500)
                                        </Typography>
                                    </Paper>
                                </Grid>
                            )}
                            {previewPhone && (
                                <Grid item xs={12} md={6}>
                                    <Paper sx={{ borderRadius: 2, overflow: "hidden", boxShadow: 2 }}>
                                        <img
                                            src={previewPhone}
                                            alt="phone preview"
                                            style={{ width: "100%", height: 200, objectFit: "contain" }}
                                        />
                                        <Typography variant="caption" display="block" mt={1} textAlign="center">
                                            Phone (1180 * 860)
                                        </Typography>
                                    </Paper>
                                </Grid>
                            )}
                        </Grid>

                        {/* Phone Image Select */}
                        <label htmlFor="upload-phone" className='mb-3'>
                            <input
                                accept="image/*"
                                id="upload-phone"
                                type="file"
                                hidden
                                onChange={handlePhoneSelect}
                            />
                            <Button
                                variant="contained"
                                component="span"
                                startIcon={<AddPhotoAlternate />}
                                sx={{ mt: 2 }}
                            >
                                Select Phone Image
                            </Button>
                        </label>

                        <TextField
                            select
                            label="Select Property"
                            fullWidth
                            sx={{ mb: 2 }}
                            value={propertyId}
                            onChange={(e) => setPropertyId(e.target.value)}
                        >
                            {properties.map((property) => (
                                <MenuItem key={property._id} value={property._id}>
                                    {property?.title}
                                </MenuItem>
                            ))}
                        </TextField>

                        <Box textAlign="right">
                            <Button
                                variant="contained"
                                color="success"
                                onClick={handleSaveImages}
                                disabled={loading}
                            >
                                {loading ? <CircularProgress size={24} color="inherit" /> : "Save"}
                            </Button>
                        </Box>
                    </Paper>
                </Modal>

                <Typography variant="subtitle1" mt={1}>Saved Images</Typography>

                <Grid container spacing={3}>
                    {images.map((img) => (
                        <Grid item xs={12} sm={6} md={4} lg={4} key={img.id}>
                            <Paper
                                elevation={3}
                                sx={{
                                    p: 1.5,
                                    borderRadius: 2,
                                    overflow: "hidden",
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    backgroundColor: "#fff",
                                }}
                            >
                                <Box sx={{ display: "flex", width: "100%", gap: 1 }}>
                                    <Box sx={{ flex: 1, textAlign: "center" }}>
                                        <Typography variant="caption" display="block" mb={0.5}>
                                            Desktop
                                        </Typography>
                                        <img
                                            src={img.bannerImage}
                                            alt="desktop banner"
                                            style={{ width: "100%", height: 120, objectFit: "cover", borderRadius: 4 }}
                                        />
                                    </Box>
                                    <Box sx={{ flex: 1, textAlign: "center" }}>
                                        <Typography variant="caption" display="block" mb={0.5}>
                                            Phone
                                        </Typography>
                                        <img
                                            src={img.phoneImage || "/placeholder.png"}
                                            alt="phone banner"
                                            style={{
                                                width: "100%",
                                                height: 120,
                                                objectFit: "contain",
                                                borderRadius: 4,
                                                backgroundColor: "#fff"
                                            }}
                                        />
                                    </Box>

                                </Box>

                                {/* Property Label */}
                                {img?.propertyId && (
                                    <Typography
                                        variant="body2"
                                        color="text.secondary"
                                        sx={{ mt: 1, textAlign: "center", width: "100%" }}
                                        noWrap
                                        title={img?.propertyId?.title || img.propertyId}
                                    >
                                        Property: {img?.propertyId?.title || img.propertyId}
                                    </Typography>
                                )}

                                <Box sx={{ mt: 1, width: "100%", textAlign: "right" }}>
                                    <IconButton
                                        size="small"
                                        onClick={() => handleDelete(img.id)}
                                        sx={{
                                            backgroundColor: "rgba(0,0,0,0.6)",
                                            color: "#fff",
                                            "&:hover": { backgroundColor: "rgba(0,0,0,0.8)" },
                                        }}
                                    >
                                        <Delete fontSize="small" />
                                    </IconButton>
                                </Box>
                            </Paper>
                        </Grid>
                    ))}
                </Grid>

            </Box>
        </Box>
    );
};

export default Backgroundimage;
